import { createScooterRequest, fetchScooterRequest, updateScooterRequest, fetchScootersRequest, deleteScooterRequest } from '../api/index'
import { handleErrorRequest } from '../helpers/api'
import _ from 'lodash'
import { createActions, handleActions } from 'redux-actions'
import { payloadIdentity, simplePayloadMutation, resetMutation } from '../helpers/redux'

const failMessageIdentity = payloadIdentity('failMessage')

const createdActions = createActions({
  scooters: {
    SUBMIT_SCOOTER_ATTEMPT: null,
    SUBMIT_SCOOTER_FAILURE: failMessageIdentity,
    SUBMIT_SCOOTER_SUCCESS: null,
    FETCH_SCOOTER_ATTEMPT: null,
    FETCH_SCOOTER_FAILURE: failMessageIdentity,
    FETCH_SCOOTER_SUCCESS: null,
    FETCH_SCOOTERS_ATTEMPT: null,
    FETCH_SCOOTERS_FAILURE: failMessageIdentity,
    FETCH_SCOOTERS_SUCCESS: null,
    DELETE_SCOOTER_ATTEMPT: null,
    DELETE_SCOOTER_FAILURE: failMessageIdentity,
    DELETE_SCOOTER_SUCCESS: null,
    SET_CURRENT_SCOOTER: payloadIdentity('currentScooter'),
    SET_SCOOTERS: payloadIdentity('scooters'),
    RESET_STATE: payloadIdentity('toOmit')
  }
})

const {
  scooters: {
    submitScooterAttempt,
    submitScooterFailure,
    submitScooterSuccess,
    deleteScooterAttempt,
    deleteScooterFailure,
    deleteScooterSuccess,
    fetchScooterAttempt,
    fetchScooterFailure,
    fetchScooterSuccess,
    fetchScootersAttempt,
    fetchScootersFailure,
    fetchScootersSuccess,
    setScooters,
    setCurrentScooter,
  }
} = createdActions

const createScooter = ({ dealer_id, customer_id, data }) => (dispatch, getState) => {
  dispatch(submitScooterAttempt())
  let jwt = _.get(getState(), 'auth.user.jwt', '')
  return createScooterRequest({ data: { scooter: data }, dealer_id, customer_id, jwt }).then(({ response, error }) => {
    if (response) {
      dispatch(submitScooterSuccess())
      return Promise.resolve(response.data)
    } else {
      dispatch(submitScooterFailure(handleErrorRequest(error)))
      return Promise.reject(error)
    }
  })
}

const fetchScooter = ({ dealer_id, customer_id, scooter_id }) => (dispatch, getState) => {
  dispatch(fetchScooterAttempt())
  let jwt = _.get(getState(), 'auth.user.jwt', '')
  return fetchScooterRequest({ scooter_id, dealer_id, customer_id, jwt }).then(({ response, error }) => {
    if (response) {
      dispatch(fetchScooterSuccess())
      dispatch(setCurrentScooter(response.data))
      return Promise.resolve(response.data)
    } else {
      dispatch(fetchScooterFailure(handleErrorRequest(error)))
      return Promise.reject(error)
    }
  })
}

const fetchScooters = ({ dealer_id, customer_id }) => (dispatch, getState) => {
  dispatch(fetchScootersAttempt())
  let jwt = _.get(getState(), 'auth.user.jwt', '')
  return fetchScootersRequest({ dealer_id, customer_id, jwt }).then(({ response, error }) => {
    if (response) {
      dispatch(fetchScootersSuccess())
      dispatch(setScooters(response.data))
      return Promise.resolve(response.data)
    } else {
      dispatch(fetchScootersFailure(handleErrorRequest(error)))
      return Promise.reject(error)
    }
  })
}

const updateScooter = ({ dealer_id, scooter_id, customer_id, data }) => (dispatch, getState) => {
  dispatch(submitScooterAttempt())
  let jwt = _.get(getState(), 'auth.user.jwt', '')
  return updateScooterRequest({ dealer_id, scooter_id, data: { scooter: data }, customer_id, jwt }).then(({ response, error }) => {
    if (response) {
      dispatch(submitScooterSuccess())
      return Promise.resolve(response.data)
    } else {
      dispatch(submitScooterFailure(handleErrorRequest(error)))
      return Promise.reject(error)
    }
  })
}

const deleteScooter = ({ dealer_id, scooter_id, customer_id }) => (dispatch, getState) => {
  dispatch(deleteScooterAttempt())
  let jwt = _.get(getState(), 'auth.user.jwt', '')
  return deleteScooterRequest({ dealer_id, scooter_id, customer_id, jwt }).then(({ response, error }) => {
    if (response) {
      dispatch(deleteScooterSuccess())
      const scooters = _.get(getState(), 'scooters.scooters', [])
      dispatch(setScooters(_.reject(scooters, { id: scooter_id })))
      return Promise.resolve(response.data)
    } else {
      dispatch(deleteScooterFailure(handleErrorRequest(error)))
      return Promise.reject(error)
    }
  })
}

const createScooterSync = (scooter) => (dispatch, getState) => {
  const scooters = getState().scooters.scooters || []
  const scooterCopy = Object.assign({}, scooter)
  dispatch(setScooters([...scooters, scooterCopy]))
}

const updateScooterSync = (scooter) => (dispatch, getState) => {
  const currentScooter = getState().scooters.currentScooter || { id: scooter.id }
  const scooters = [...getState().scooters.scooters]
  var index = _.findIndex(scooters, { id: currentScooter.id })
  if (index !== -1) {
    scooters.splice(index, 1, Object.assign({}, currentScooter, scooter))
    dispatch(setScooters([...scooters]))
  }
  dispatch(setCurrentScooter(null))
}

const deleteScooterSync = (scooter_id) => (dispatch, getState) => {
  const scooters = getState().scooters.scooters || []
  const currentScooter = getState().scooters.currentScooter || {}
  let nextScooters = _.reject(scooters, { id: scooter_id })
  dispatch(setScooters(nextScooters))
  scooter_id === currentScooter.id && dispatch(setCurrentScooter(null))
}

export const actions = {
  ...createdActions.scooters,
  createScooter,
  createScooterSync,
  updateScooter,
  updateScooterSync,
  deleteScooter,
  deleteScooterSync,
  fetchScooter,
  fetchScooters
}

export const initialState = {
  submittingScooter: false,
  failSubmitScooter: null,
  successSubmitScooter: false,
  fetchingScooter: false,
  failFetchScooter: null,
  successFetchScooter: false,
  currentScooter: null,
  fetchingScooters: false,
  failFetchScooters: null,
  successFetchScooters: false,
  scooters: null
}

export default handleActions({
  scooters: {
    SUBMIT_SCOOTER_ATTEMPT: (state, action) =>
      ({ ...state, submittingScooter: true, failSubmitScooter: null, successSubmitScooter: false }),
    SUBMIT_SCOOTER_SUCCESS: (state, action) =>
      ({ ...state, submittingScooter: false, failSubmitScooter: null, successSubmitScooter: true }),
    SUBMIT_SCOOTER_FAILURE: (state, { payload: { failMessage } }) =>
      ({ ...state, submittingScooter: false, failSubmitScooter: failMessage, successSubmitScooter: false }),
    DELETE_SCOOTER_ATTEMPT: (state, action) =>
      ({ ...state, submittingScooter: true, failSubmitScooter: null, successSubmitScooter: false }),
    DELETE_SCOOTER_SUCCESS: (state, action) =>
      ({ ...state, submittingScooter: false, failSubmitScooter: null, successSubmitScooter: true }),
    DELETE_SCOOTER_FAILURE: (state, { payload: { failMessage } }) =>
      ({ ...state, submittingScooter: false, failSubmitScooter: failMessage, successSubmitScooter: false }),
    FETCH_SCOOTER_ATTEMPT: (state, action) =>
      ({ ...state, fetchingScooter: true, failFetchScooter: null, successFetchScooter: false }),
    FETCH_SCOOTER_SUCCESS: (state, action) =>
      ({ ...state, fetchingScooter: false, failFetchScooter: null, successFetchScooter: true }),
    FETCH_SCOOTER_FAILURE: (state, { payload: { failMessage } }) =>
      ({ ...state, fetchingScooter: false, failFetchScooter: failMessage, successFetchScooter: false }),
    FETCH_SCOOTERS_ATTEMPT: (state, action) =>
      ({ ...state, fetchingScooters: true, failFetchScooters: null, successFetchScooters: false }),
    FETCH_SCOOTERS_SUCCESS: (state, action) =>
      ({ ...state, fetchingScooters: false, failFetchScooters: null, successFetchScooters: true }),
    FETCH_SCOOTERS_FAILURE: (state, { payload: { failMessage } }) =>
      ({ ...state, fetchingScooters: false, failFetchScooters: failMessage, successFetchScooters: false }),
    SET_CURRENT_SCOOTER: simplePayloadMutation,
    SET_SCOOTERS: simplePayloadMutation,
    RESET_STATE: resetMutation(initialState)
  }
}, initialState)
